import React from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useHistory } from 'react-router-dom';
import { Button, Stack, Typography } from '@mui/material';
import { confidenceColor } from '../lib/fieldGroups';

interface ReviewHeaderProps {
  overallConfidence: number | null;
}

const confidenceLabel = (score: number): string => {
  if (score >= 0.85) return 'High';
  if (score >= 0.65) return 'Medium';
  return 'Low';
};

export const ReviewHeader = ({ overallConfidence }: ReviewHeaderProps) => {
  const history = useHistory();

  return (
    <Stack spacing={1} sx={{ mb: 2 }}>
      <Button
        size="small"
        color="primary"
        startIcon={<ArrowBackIosNewIcon sx={{ fontSize: 14 }} />}
        onClick={() => history.goBack()}
        sx={{ alignSelf: 'flex-start' }}
      >
        Back
      </Button>
      <Stack direction="row" spacing={3} alignItems="flex-start" justifyContent="space-between" flexWrap="wrap">
        <Stack spacing={0.5}>
          <Typography variant="h6">Review Extracted Terms</Typography>
          <Typography variant="body2">Verify each field, click to edit, then confirm to save to submission.</Typography>
        </Stack>
        {overallConfidence != null && (
          <Stack direction="row" spacing={0.75} alignItems="center">
            <Typography variant="subtitle2" color="text.secondary">
              Confidence Score:
            </Typography>
            <CheckCircleIcon sx={{ fontSize: 18, color: confidenceColor(overallConfidence) }} />
            <Typography variant="subtitle2" sx={{ color: confidenceColor(overallConfidence) }}>
              {Math.round(overallConfidence * 100)}% - {confidenceLabel(overallConfidence)}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};
